/**
 * TabLayout — 하단 탭이 있는 메인 섹션 레이아웃
 *
 * journey·explore·review·profile 을 감싸고 AppTabBar를 항상 표시.
 * 전체화면(레슨·모의고사·대화·온보딩)은 이 레이아웃 밖에 둔다.
 */

import { Outlet } from 'react-router-dom';
import AppTabBar from './AppTabBar';

/**
 * 핸드오프 컨셉: 콘텐츠는 flex:1로 내부 스크롤, 탭바는 그 아래 별도 영역(고정 오버레이 아님).
 * 콘텐츠가 탭바 밑으로 겹치지 않는다 — 스크롤 영역이 탭바 위로 한정된다.
 */
export default function TabLayout() {
  return (
    <div className="flex flex-col" style={{ height: 'calc(100dvh - env(safe-area-inset-top) - env(safe-area-inset-bottom))' }}>
      <div className="min-h-0 flex-1 overflow-y-auto">
        <Outlet />
      </div>
      <AppTabBar />
    </div>
  );
}
